import React, { useState } from "react";
import CheckoutPopup from "../CheckoutPopup/CheckoutPopup";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "sonner";
import drawdownIcon from "../../../../Assets/Images/drawdownIcon.svg";
import newsIcon from "../../../../Assets/Images/news.svg";
import newTradingIcon from "../../../../Assets/Images/newTradingIcon.svg";
import { RotateCcw } from "lucide-react";
import { getPublishableKeyAction } from "../../../../Redux/PaymentsPurchase/PaymentPurchaseActions";
import { useAuth } from "@clerk/clerk-react";

function AddonCard({ text, price, enabled, title, status }) {
  const [clicked, setClicked] = useState(false);
  const { getToken } = useAuth();
  const dispatch = useDispatch();
  const { challengeStageInfo } = useSelector(
    (state) => state.ChallengeOverviewReducer
  );

  const handleClick = () => {
    dispatch(getPublishableKeyAction(getToken));

    setClicked(true);
  };

  return (
    <>
      <div className="flex-1 h-full w-full bg-background-secondary p-4 py-2 flex rounded-lg mt-4 flex-col justify-between gap-2">
        <div
          className={`bg-[#2197ed12] flex items-center justify-center !aspect-square w-fit rounded-full ${
            title === "Retry Challenge" ? "p-3" : "p-4"
          }`}
        >
          {title === "Retry Challenge" ? (
            <RotateCcw stroke="var(--primary)" className="w-5" />
          ) : (
            <img src={newsIcon} alt="drawdoenIcon" className="w-4" />
          )}
        </div>
        <div className="text-sm font-N_Bold -mb-2">{title}</div>
        <div className="text-xs font-N_Thin text-white-opacity">{text}</div>
        {!enabled ? (
          <div className="flex items-center gap-4">
            <div
              className={`text-xs font-N_Bold border-2 border-primary rounded-full text-primary py-1 px-3 text-center w-full max-w-[7rem] ${
                status === "ACTIVE" && title != "Retry Challenge"
                  ? "cursor-pointer"
                  : status != "ACTIVE" && title == "Retry Challenge"
                  ? "cursor-pointer"
                  : "opacity-30 cursor-not-allowed"
              }`}
              onClick={() => {
                !challengeStageInfo?.isLive
                  ? status === "ACTIVE" && title != "Retry Challenge"
                    ? handleClick()
                    : status != "ACTIVE" && title == "Retry Challenge"
                    ? handleClick()
                    : status === "ACTIVE" && title == "Retry Challenge"
                    ? toast.error(
                        "Can't purchase this addon on active challenges!",
                        {
                          autoClose: 2000,
                          className: "bg-red-opacity text-red",
                        }
                      )
                    : toast.error(
                        "Can't purchase addon on closed challenges!",
                        {
                          autoClose: 2000,
                          className: "bg-red-opacity text-red",
                        }
                      )
                  : toast.error("Can't purchase addon in live stage!", {
                      autoClose: 2000,
                      className: "bg-red-opacity text-red",
                    });
              }}
            >
              Add
            </div>
            <div
              className={`flex gap-2 items-end text-primary font-N_Bold ${
                status === "ACTIVE" && title != "Retry Challenge"
                  ? "cursor-pointer"
                  : status != "ACTIVE" && title == "Retry Challenge"
                  ? "cursor-pointer"
                  : "opacity-30 cursor-not-allowed"
              }`}
            >
              <span className="text-xs text-white-opacity opacity-50 font-N_Roman">
                at
              </span>
              {price?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 0,
                maximumFractionDigits: 3,
              })}
            </div>
          </div>
        ) : (
          <div className="text-base font-N_Bold bg-primary  rounded-md py-1 px-3 cursor-not-allowed text-center min-w-[34%] ">
            Enabled!
          </div>
        )}
      </div>
      <CheckoutPopup
        open={clicked}
        setOpen={setClicked}
        totalAmount={price}
        title={title}
      />
    </>
  );
}

export default AddonCard;
